<template>
    <div class="main-page">
        <div class="sales-land-page" v-if="salesCard != null && saleItem != null && saleFilterParams != null">
            <promoLand></promoLand>
            <mainLand v-if="salesCard.project_shablon_fields.prems_init == 'true'" id="land-prems"></mainLand>
            <aboutLand v-if="salesCard.project_shablon_fields.about_init == 'true'" id="land-about"></aboutLand>
            <locationLand v-if="salesCard.project_shablon_fields.location_init == 'true'" id="land-location"></locationLand>
            <aroundLandCards v-if="salesCard.project_shablon_fields.around_cards_init != null && salesCard.project_shablon_fields.around_cards_init == 'true'" id="land-around-cards"></aroundLandCards>
            <aroundLand v-if="salesCard.project_shablon_fields.around_init == 'true'" id="land-around"></aroundLand>
            <moreInfoLandGp v-if="salesCard.project_shablon_fields.gp_more_info_init != null && salesCard.project_shablon_fields.gp_more_info_init == 'true'" id="land-moreinfo-gp"></moreInfoLandGp>
            <!-- Только для Duman -->
            <streetLand v-if="salesCard.project_shablon_fields.street_init == 'true' && projectNameG == 'duman'" id="land-street"></streetLand> 
            <!-- end only for DUMAN -->
            <genplanLand v-if="salesCard.project_shablon_fields.genplan_init == 'true'" id="land-genplan"></genplanLand>
            <archLand v-if="salesCard.project_shablon_fields.arch_init == 'true'" id="land-arch"></archLand>
            <commerceLand v-if="salesCard.project_shablon_fields.commerce_init == 'true'" id="land-commerce"></commerceLand>
            <streetLand v-if="salesCard.project_shablon_fields.street_init == 'true' && projectNameG != 'duman'" id="land-street"></streetLand>
            <dvorLand v-if="salesCard.project_shablon_fields.yard_init == 'true'" id="land-yard"></dvorLand>
            <moreInfoLand v-if="salesCard.project_shablon_fields.more_info_init != null && salesCard.project_shablon_fields.more_info_init == 'true'" id="land-moreinfo"></moreInfoLand>
            <lobbiLand v-if="salesCard.project_shablon_fields.lobbi_init == 'true'" id="land-lobbi"></lobbiLand>
            <safeLand v-if="salesCard.project_shablon_fields.safe_init == 'true'" id="land-safe"></safeLand>
            <formLand id="land-form-top"></formLand>
            <flatsLand v-if="salesCard.project_shablon_fields.flats_init == 'true'" id="land-flats"></flatsLand>
            <CRMflats v-if="salesCard.project_shablon_fields.flats_plans_init == 'true' && salesCardPage != null" id="land-plans"></CRMflats>
            <formLand></formLand>
            <galleryLand v-if="salesCard.project_shablon_fields.gallery_init == 'true'" id="land-gallery"></galleryLand>
            <newsLand v-if="salesCard.project_shablon_fields.news_init == 'true'" id="land-news"></newsLand>
            <contactsLand v-if="salesCard.project_shablon_fields.contacts_init == 'true' && saleItem != null" id="land-contacts"></contactsLand>
            <formLand class="over-footer-form"></formLand>
            <infoSectionLand></infoSectionLand>
            
            
            <!-- <formLand :promoForm="CityProjectSales" v-if="contactsSetup && salesCard.project_land_site.contacts_init == 'true'"></formLand> -->
            <!-- <div class="container">
                <sharePostBottom :options="[{title: 'Поделиться ' + CapitalizeID(projectNameG) +  ':', data_title: CapitalizeID(projectNameG) + ' - ' + salesCard.project_title, data_link: 'https://' + projectNameG + '.bazis.kz', data_page: 'Sales_Land - ' + CapitalizeID(projectNameG), data_page_key: 'sales-land-page'}]" v-if="projectNameG != 'yassytower'"></sharePostBottom>
                <sharePostBottom :options="[{title: 'Поделиться ' + CapitalizeID(projectNameG) +  ':', data_title: CapitalizeID(projectNameG) + ' - ' + salesCard.project_title, data_link: 'https://' + projectNameG + '.kz', data_page: 'Sales_Land - ' + CapitalizeID(projectNameG), data_page_key: 'sales-land-page'}]" v-if="projectNameG == 'yassytower'"></sharePostBottom>
                <div class="rules-of-sales" v-if="salesCard != null && salesCardPage != null">
                    <p v-html="salesCard.project_zakon_desc" v-if="salesCard.project_zakon_desc != null"></p>
                    <p v-if="salesCardPage.land_footer_zakon_desc != null">{{salesCardPage.land_footer_zakon_desc}}</p>
                </div>
            </div> -->
        </div>
        <div class="global-overlay" :class="{'open' : isOpenSendwich, 'open' : isOpenSendwichMobile}" @click="closeMobileMenu(false)">
            <!-- <div class="global-overlay-ripple" :class="{animatedEnd: animatedEnd}"></div> -->
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import promoLand from '@/components/sales-land-partials/land-promo.vue'
    import mainLand from '@/components/sales-land-partials/land-main.vue'
    import aboutLand from '@/components/sales-land-partials/land-about.vue'
    import locationLand from '@/components/sales-land-partials/land-location.vue'
    import aroundLandCards from '@/components/sales-land-partials/land-around-cards.vue'
    import aroundLand from '@/components/sales-land-partials/land-around.vue'
    import genplanLand from '@/components/sales-land-partials/land-genplan.vue'
    import archLand from '@/components/sales-land-partials/land-arch.vue'
    import streetLand from '@/components/sales-land-partials/land-street.vue'
    import commerceLand from '@/components/sales-land-partials/land-commerce.vue'
    import dvorLand from '@/components/sales-land-partials/land-dvor.vue'
    import moreInfoLandGp from '@/components/sales-land-partials/land-more-info-gp.vue'
    import moreInfoLand from '@/components/sales-land-partials/land-more-info.vue'
    import lobbiLand from '@/components/sales-land-partials/land-lobbi.vue'
    import safeLand from '@/components/sales-land-partials/land-safe.vue'
    import flatsLand from '@/components/sales-land-partials/land-flats.vue'
    import galleryLand from '@/components/sales-land-partials/land-gallery.vue'
    import newsLand from '@/components/sales-land-partials/land-news.vue'
    import contactsLand from '@/components/sales-land-partials/land-contacts.vue'
    import infoSectionLand from '@/components/sales-land-partials/land-info.vue'
    
    import formLand from '@/components/forms/form-sales-land.vue'
    import CRMflats from '@/components/flats-crm/flats-crm-section.vue'
    
    export default {
        name: 'main--page',
        components: {
            promoLand,
            mainLand,
            aboutLand,
            locationLand,
            aroundLandCards,
            aroundLand,
            genplanLand,
            archLand,
            streetLand,
            commerceLand,
            dvorLand,
            moreInfoLandGp,
            moreInfoLand,
            lobbiLand,
            safeLand,
            flatsLand,
            galleryLand,
            newsLand,
            contactsLand,
            infoSectionLand,

            formLand,
            CRMflats,
        },
        data () {
            return {
                DomLoaded: false,
                iSmobile: false,
                formInit: false,
                projectNameG: window.host,
                lang: window.GlobalLang,
            }
        },
        computed: mapGetters({
            setup: 'loadPageSetUp',
            salesCard: 'loadSalesCardContent',
            salesCardPage: 'loadSalesCardPage',
            saleItem: 'loadSaleCardItem',
            saleFilterParams: 'loadSalesFilterCardParams',
            contactsSetup: 'loadContactsPage',

            isOpenFormModal: 'loadisOpenFormModal',
            isOpenSendwich: 'loadIsOpenSendwich',
            isOpenSendwichMobile: 'loadIsOpenSendwichMobile',
        }),
        methods: {
            CapitalizeID(s) {
                if (typeof s !== 'string') return ''
                return s.charAt(0).toUpperCase() + s.slice(1)
            },
            closeMobileMenu(data) {
                this.$store.commit('Open_sendwich_mobile', data);
                document.getElementsByTagName('body')[0].classList.remove('overlay-open');
            },
            // removeLoaderPage() {
            //     var loader = document.getElementById('loader');
            //     loader.classList.remove("InitLoader");
            //     setTimeout(()=>{
            //         loader.remove();
            //     },500);
            // },
        },
        created () {
        },
        mounted() {
        }
    }
</script>